import { render, staticRenderFns } from "./LTag.vue?vue&type=template&id=01a54942"
import script from "./LTag.vue?vue&type=script&lang=js"
export * from "./LTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports